import {
    AUTHORIZATION_RECEIVE_LOGIN,
    COMPANIES_UPDATED,
    SCOPE_FULL_SET
} from "../config/actions";
import {fork, takeEvery, select, call, put, all} from "redux-saga/effects";
import CompanyApi from "../apis/CompanyApi";
import {setCompanies} from "../actions/companyAction";

const loadCompaniesFromApi = async () =>
    CompanyApi.loadCompanies()
        .then((response) => {
            if (response.status === 200 && response.data.success) {
                return response.data.data;
            }
            return null;
        });

function* doLoadCompanies() {
    try {
        let backendModules = yield select((state) => state.scope.full ? state.scope.full.backendModules : null);
        if (backendModules && backendModules.includes('COMPANIES')) {
            const result = yield call(loadCompaniesFromApi);
            if (result) {
                yield put(setCompanies(result));
            }
        }
    } catch (e) {
        console.log('error', e);
    }
}

export function* loadCompanies() {
    yield takeEvery([AUTHORIZATION_RECEIVE_LOGIN, SCOPE_FULL_SET, COMPANIES_UPDATED], doLoadCompanies);
}

export default function* rootSaga() {
    yield all([fork(loadCompanies)]);
}
